const topic = () => {
  const SELECTOR = "#js-article-content iframe";
  const INTERVAL = 500;
  const TIMEOUT = 30000;

  let timer = null;
  let lastFoundAt = Date.now();

  /* 1. 立即隐藏（不依赖 load） */
  function hideFrame(f) {
    if (!f.style.opacity) {
      f.style.opacity = "0";
      f.style.transition = "opacity .3s ease";
      f.style.pointerEvents = "none";
    }
  }

  /* 2. 高度处理 & 淡入（等 load 后） */
  function finishHeight(f) {
    try {
      // const inner = f.contentWindow.document.getElementById(
      //   "topic_cards-article"
      // );
      const inner = f.contentWindow.document.body;

      if (!inner) return; // 内部节点还没好，等下一轮
      const h = inner.getBoundingClientRect().height;
      if (f.style.height !== `${h}px`) f.style.height = `${h}px`;
      f.style.opacity = "1";
      f.style.pointerEvents = "auto";
      f.dataset.heightFixed = "1"; // 打标
      lastFoundAt = Date.now();
    } catch (e) {
      f.dataset.heightFixed = "1"; // 跨域等异常直接放弃
    }
  }

  /* 轮询：只扫未打标的 */
  function poll() {
    const now = Date.now();
    let hasNew = false;

    document.querySelectorAll(SELECTOR).forEach(f => {
      if (f.dataset.heightFixed) return; // 已处理过
      hasNew = true;

      hideFrame(f); // ① 立刻隐藏

      if (f.dataset.listening) return; // 已监听 load，等事件
      f.dataset.listening = "1";

      /* ② 等 iframe 加载完再做高度 */
      f.addEventListener("load", () => finishHeight(f), { once: true });

      /* 如果已经加载完成（缓存）立即执行 */
      if (
        f.contentWindow &&
        f.contentDocument &&
        (f.contentDocument.readyState === "complete" ||
          f.contentDocument.readyState === "interactive")
      ) {
        finishHeight(f);
      }
    });

    /* 30 s 无新 iframe 清定时器 */
    if (!hasNew && now - lastFoundAt > TIMEOUT) {
      clearInterval(timer);
      timer = null;
    }
  }

  /* 启动 */
  window.addEventListener("load", () => {
    poll();
    timer = setInterval(poll, INTERVAL);
  });
};

export default topic;
